export default "__VITE_ASSET__efcc516e__"